import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import "./Sale.css";
import api from "../../../utils/axios";
import Axios from "axios";
import TableCustomer from "../../components/Table/TableSale";
import ContactResultModal from "../../components/Modal/Contract";
import CustomerModal from "../../components/Modal/CustomerModal";
import CustomerListModal from "../../components/Modal/Sale/CustomersModal";
import ImportCustomerModal from "../../components/Modal/Sale/ImportCustomerModal";
import CalendarWrapper from "../../components/Calendar/CalendarWrapper";
import CallModal from "../../components/Modal/CallModal";
import AppointmentModal from "../../components/Modal/AppointmentModal";
import Loading from "../../components/Loading";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import SearchFilter from "../../components/Search/newSearch";
import Swal from "sweetalert2";
import ModalContainer from "../../../utils/ModalContainer";
import { hasOrgPermissionKey } from "../../../utils/orgAccessPermissions";

const SALE_LIST_STATE_KEY = "saleListState";
const SALE_FOCUS_AR_KEY = "saleFocusArId";

export default function Page({ embedded = false, selectedDate = null, buttonType  }) {
  // ------------------ STATES หลัก ------------------
  const [customers, setCustomers] = useState([]);           //  page ปัจจุบัน
  const [allCustomers, setAllCustomers] = useState([]);     //  ทั้งหมดจาก server (ไม่ paginate)
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [authData, setAuthData] = useState({});
  const [filterParams, setFilterParams] = useState({});
  const [todayCustomers, setTodayCustomers] = useState([]);
  const [myCustomers, setMyCustomers] = useState([]);
  const [unassignedCustomers, setUnassignedCustomers] = useState([]);

  // ------------------ MODALS ------------------
  const [openCustomerModal, setOpenCustomerModal] = useState(false);
  const [openCustomerListModal, setOpenCustomerListModal] = useState(false);
  const [openImportModal, setOpenImportModal] = useState(false);
  const [importCustomers, setImportCustomers] = useState([]);
  const [openCalendar, setOpenCalendar] = useState(false);

  // ------------------ CALL / APPOINTMENT MODAL ------------------
  const [openCallModal, setOpenCallModal] = useState(false);
  const [callData, setCallData] = useState(null);
  const [openAppointmentModal, setOpenAppointmentModal] = useState(false);
  const [appointmentData, setAppointmentData] = useState(null);

  // ------------------ PAGINATION ------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalFromServer, setTotalFromServer] = useState(0);

  const [sortField, setSortField] = useState("index");
  const [sortOrder, setSortOrder] = useState("desc");
  const [tableKey, setTableKey] = useState(0);
  const [focusedArId, setFocusedArId] = useState(null);
  const [branches, setBranches] = useState([]);
  const [quotedCustomerBranchKeys, setQuotedCustomerBranchKeys] = useState(new Set());
  const [branchFilter, setBranchFilter] = useState(
    () => localStorage.getItem("saleBranchFilter") || "all"
  );

  // ------------------ MODAL กลุ่ม ------------------
  const [openGroupModal, setOpenGroupModal] = useState(false);
  const [groupType, setGroupType] = useState("");
  const [activeGroup, setActiveGroup] = useState(() => {
    return localStorage.getItem("activeGroup") || "all";
  });

  useEffect(() => {
    localStorage.setItem("activeGroup", activeGroup);
  }, [activeGroup]);

  useEffect(() => {
    if (initialLoadRef.current) return;
    try {
      localStorage.setItem(
        SALE_LIST_STATE_KEY,
        JSON.stringify({
          currentPage,
          itemsPerPage,
          activeGroup,
          sortField,
          sortOrder,
        })
      );
    } catch {}
  }, [currentPage, itemsPerPage, activeGroup, sortField, sortOrder]);

  const initialLoadRef = useRef(true);
  const tableWrapperRef = useRef(null);

  const hasValidQuote = (customer, selectedBranch = "all") => {
    const customerArId = Number(customer?.AR_Id);
    if (
      selectedBranch !== "all" &&
      Number.isFinite(customerArId) &&
      quotedCustomerBranchKeys.size > 0
    ) {
      return quotedCustomerBranchKeys.has(`${String(selectedBranch)}:${customerArId}`);
    }

    const services = Array.isArray(customer?.Services) ? customer.Services : [];
    return services.some((service) => {
      const quotes = Array.isArray(service?.Quotes) ? service.Quotes : [];
      return quotes.some((quote) => {
        const quoteNo = String(quote?.Quote_No || "").trim();
        return quoteNo !== "" && quoteNo !== "-";
      });
    });
  };

  // Reset table scroll when customers or filters change
  useLayoutEffect(() => {
    if (initialLoadRef.current) return;
    
    // Use setTimeout to ensure DOM has updated
    setTimeout(() => {
      const wrapper = document.querySelector('.table-wrapper-scroll');
      if (wrapper) {
        wrapper.scrollLeft = 0;
        // Force reflow
        void wrapper.offsetHeight;
      }
    }, 0);
  }, [customers, filterParams, tableKey]);

  // ---------------- โหลด Auth ----------------
  const initialize = async () => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/authen`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            key: process.env.REACT_APP_ANALYTICS_KEY,
          },
        }
      );
      if (response.data.status === "OK") {
        setAuthData(response.data.decoded || {});
      } else {
        window.location.replace("/login");
      }
    } catch {
      window.location.replace("/login");
    }
  };

  const loadBranches = async () => {
    try {
      const [branchResponse, quoteResponse] = await Promise.all([
        Axios.get(`${process.env.REACT_APP_API_URL}/api/app/org/branches`, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }),
        api.get("/get-quotes"),
      ]);

      const allBranches =
        branchResponse.data?.status === "OK" && Array.isArray(branchResponse.data?.results)
          ? branchResponse.data.results
          : [];

      const quoteRows = Array.isArray(quoteResponse.data?.result)
        ? quoteResponse.data.result
        : [];

      const nextQuotedCustomerBranchKeys = new Set(
        quoteRows
          .map((q) => {
            const branchId = Number(q?.Branch_Id);
            const arId = Number(q?.AR_Id);
            const docNo = String(q?.Doc_No || "").trim();
            if (!Number.isFinite(branchId) || branchId <= 0) return null;
            if (!Number.isFinite(arId) || arId <= 0) return null;
            if (!docNo || docNo === "-") return null;
            return `${branchId}:${arId}`;
          })
          .filter(Boolean)
      );
      setQuotedCustomerBranchKeys(nextQuotedCustomerBranchKeys);

      const quotedBranchIds = new Set(
        quoteRows
          .map((q) => Number(q?.Branch_Id))
          .filter((id) => Number.isFinite(id) && id > 0)
      );

      const filteredBranches = allBranches.filter((branch) =>
        quotedBranchIds.has(Number(branch?.Branch_Id))
      );

      setBranches(filteredBranches);

      if (
        branchFilter !== "all" &&
        !filteredBranches.some((branch) => String(branch?.Branch_Id) === String(branchFilter))
      ) {
        setBranchFilter("all");
      }
    } catch {
      setBranches([]);
    }
  };

  //  โหลดลูกค้าทั้งหมด (ไม่ paginate)
  const loadAllCustomers = async (filters = {}) => {
    try {
      const res = await api.get("/get-tb-set-ar", {
        params: {
          page: 1,
          limit: 999999,
          ...filters,
          ...(branchFilter !== "all" ? { branch_id: branchFilter } : {}),
        },
      });
      const allData = res.data?.result || [];
      const nextAllData =
        branchFilter === "all"
          ? allData
          : allData.filter((customer) => hasValidQuote(customer, branchFilter));
      
      // ไม่กรองตามพนักงาน - แสดงทั้งหมด
      setAllCustomers(nextAllData);
    } catch (error) {
      console.error("โหลดข้อมูลลูกค้าทั้งหมดล้มเหลว:", error);
    }
  };

  const reloadCustomers = async (
    page = 1,
    limit = itemsPerPage,
    filters = {},
    options = {}
  ) => {
    try {
      setLoading(true);
      const sortFieldParam = options.sortField ?? sortField;
      const sortOrderParam = options.sortOrder ?? sortOrder;

      const params = {
        page,
        limit,
        ...filters,
        ...(branchFilter !== "all" ? { branch_id: branchFilter } : {}),
        sortField: sortFieldParam,
        sortOrder: sortOrderParam,
      };


      const res = await api.get("/get-tb-set-ar", { params });

      const result = res.data?.result || [];
      const nextResult =
        branchFilter === "all"
          ? result
          : result.filter((customer) => hasValidQuote(customer, branchFilter));
      
      // ไม่กรองตามพนักงาน - แสดงทั้งหมด
      
      // Force table re-render when data changes (especially when empty)
      setTableKey(prev => prev + 1);
      
      setCustomers(nextResult);
      setFilteredCustomers(nextResult);
      setTotalFromServer(res.data?.totalRecords || 0);
      setCurrentPage(page);
      setTotalRecords(res.data?.totalRecords || 0);

    } catch (error) {
      console.error(error);
      // Force table re-render on error too
      setTableKey(prev => prev + 1);
      setCustomers([]);
      setFilteredCustomers([]);
      Swal.fire("ผิดพลาด", "โหลดข้อมูลลูกค้าไม่ได้", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!allCustomers || allCustomers.length === 0) {
      setTodayCustomers([]);
      setMyCustomers([]);
      setUnassignedCustomers([]);
      return;
    }

    const todayStr = new Date().toISOString().split("T")[0];
    const empId = authData?.Emp_Id || localStorage.getItem("emp_id");
    const empName = authData?.Emp_Name || localStorage.getItem("name");
    const role = localStorage.getItem("role");

    // กรองเฉพาะ today - แสดงเฉพาะของพนักงานคนนี้ (ยกเว้น Admin)
    const todayList = allCustomers.filter((c) => {
      // Admin เห็นทั้งหมด
      if (role === "Admin") {
        return c.Services?.some((s) => {
          const hasTodayCall = s.Calls?.some((call) => call?.Call_Date?.startsWith?.(todayStr));
          const hasTodayAppoint = s.Appointments?.some((a) => a?.Appoint_Date?.startsWith?.(todayStr));
          return hasTodayCall || hasTodayAppoint;
        });
      }
      
      // ไม่ใช่ Admin - กรองตามพนักงาน
      return c.Services?.some((s) => {
        const hasTodayCall = s.Calls?.some((call) => call?.Call_Date?.startsWith?.(todayStr));
        const hasTodayAppoint = s.Appointments?.some((a) => a?.Appoint_Date?.startsWith?.(todayStr));
        if (!hasTodayCall && !hasTodayAppoint) return false;
        
        // ตรวจสอบว่าเป็นของพนักงานคนนี้หรือไม่
        const matchById = empId && String(s?.Sale_Emp_Id || "") === String(empId);
        const matchByName = empName && s?.Sale_Emp_Name && 
          String(s.Sale_Emp_Name).trim() === String(empName).trim();
        
        return matchById || matchByName;
      });
    });

    // กรอง "ลูกค้าของฉัน" ตามเงื่อนไข:
    // 1. ถ้าลูกค้าคนใดมี Quote_No (ใบเสนอราคา) ใน Service ใด Service หนึ่ง → แสดงเฉพาะ sale ที่สร้างใบเสนอราคาล่าสุด (Created_By_Name) เท่านั้น
    // 2. ถ้าลูกค้าไม่มี Quote_No เลย → ตรวจสอบ Calls ถ้ามี Call ใดที่มี Sale_Emp_Name ตรงกับ localStorage name ให้แสดง
    const myList = allCustomers.filter((c) => {
      // รวบรวม Quotes ทั้งหมดจากทุก Service
      const allQuotes = c.Services?.flatMap((s) => 
        (s.Quotes || []).filter(q => q.Quote_No)
      ) || [];
      
      if (allQuotes.length > 0) {
        // หา Quote ล่าสุด (เรียงตาม Quote_Id ที่มากที่สุด)
        const latestQuote = allQuotes.sort((a, b) => {
          return (b.Quote_Id || 0) - (a.Quote_Id || 0);
        })[0];
        
        // ถ้า Quote ล่าสุดมี Doc_Status = 3 (ยกเลิก) → แสดงได้ทุกคน (ใช้เงื่อนไข Call)
        if (Number(latestQuote?.Doc_Status) === 3) {
          // ตรวจสอบจาก Calls
          return c.Services?.some((s) => {
            const hasMatchingCall = s.Calls?.some((call) => {
              const callEmpName = call?.Sale_Emp_Name;
              if (callEmpName) {
                return String(callEmpName).trim() === String(empName).trim();
              }
              return false;
            });
            return hasMatchingCall;
          });
        }
        
        // ตรวจสอบว่า Quote ล่าสุดมี Sale_Emp_Name ตรงกับ localStorage name หรือไม่
        if (latestQuote?.Sale_Emp_Name) {
          // Sale_Emp_Name ใน Quote คือ Created_By_Name จาก QT_H
          return String(latestQuote.Sale_Emp_Name).trim() === String(empName).trim();
        }
        return false;
      }
      
      // ถ้าลูกค้าไม่มี Quote_No → ตรวจสอบจาก Calls
      // ถ้ามี Call ใด Call หนึ่งที่มี Sale_Emp_Name ตรงกับ localStorage name ให้แสดง
      return c.Services?.some((s) => {
        const hasMatchingCall = s.Calls?.some((call) => {
          const callEmpName = call?.Sale_Emp_Name;
          if (callEmpName) {
            return String(callEmpName).trim() === String(empName).trim();
          }
          return false;
        });
        return hasMatchingCall;
      });
    });

    const unassignedList = allCustomers.filter((c) =>
      c.Services?.some((s) => !s?.Sale_Emp_Name || s?.Sale_Emp_Name?.trim() === "")
    );

    setTodayCustomers(todayList);
    setMyCustomers(myList);
    setUnassignedCustomers(unassignedList);
  }, [allCustomers, authData]);

  //  โหลดครั้งแรก
  useEffect(() => {
    (async () => {
      await initialize();
      await loadBranches();

      let savedFilters = {};
      let savedListState = {};
      try {
        const raw = localStorage.getItem("customerFilters");
        if (raw) {
          const parsed = JSON.parse(raw);
          const hasValue =
            parsed && Object.values(parsed).some((v) => v !== "" && v !== null && v !== undefined);
          if (hasValue) savedFilters = parsed;
        }
      } catch (e) {
        console.warn("อ่าน customerFilters ไม่ได้:", e);
      }

      try {
        const rawListState = localStorage.getItem(SALE_LIST_STATE_KEY);
        if (rawListState) {
          savedListState = JSON.parse(rawListState) || {};
        }
      } catch (e) {
        console.warn("อ่าน saleListState ไม่ได้:", e);
      }

      const restoredPage =
        Number.isFinite(Number(savedListState.currentPage)) &&
        Number(savedListState.currentPage) > 0
          ? Number(savedListState.currentPage)
          : 1;
      const restoredPageSize =
        Number.isFinite(Number(savedListState.itemsPerPage)) &&
        Number(savedListState.itemsPerPage) > 0
          ? Number(savedListState.itemsPerPage)
          : itemsPerPage;
      const restoredSortField = savedListState.sortField || "index";
      const restoredSortOrder = savedListState.sortOrder || "desc";
      const restoredGroup =
        savedListState.activeGroup || localStorage.getItem("activeGroup") || "all";

      setCurrentPage(restoredPage);
      setItemsPerPage(restoredPageSize);
      setSortField(restoredSortField);
      setSortOrder(restoredSortOrder);
      setActiveGroup(restoredGroup);

      setFilterParams(savedFilters);
      setFocusedArId(localStorage.getItem(SALE_FOCUS_AR_KEY) || null);

      await loadAllCustomers(savedFilters);       //  โหลดทั้งหมด
      await reloadCustomers(restoredPage, restoredPageSize, savedFilters, {
        sortField: restoredSortField,
        sortOrder: restoredSortOrder,
      }); //  โหลดเฉพาะหน้าตามที่ค้างไว้

      initialLoadRef.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (initialLoadRef.current) return;
    localStorage.setItem("saleBranchFilter", branchFilter);
    setCurrentPage(1);
    (async () => {
      await loadAllCustomers(filterParams);
      await reloadCustomers(1, itemsPerPage, filterParams);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchFilter]);


  //  เมื่อเปลี่ยนหน้า/จำนวนต่อหน้า
  useEffect(() => {
    if (initialLoadRef.current) return;
    reloadCustomers(currentPage, itemsPerPage, filterParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, itemsPerPage]);

  const provinceOptions = Array.from(
    new Set(
      allCustomers.flatMap((c) => {
        const fromAR = c.ProvinceName ? [c.ProvinceName] : [];
        const fromServices = (c.Services || [])
          .map((s) => s?.ProvinceName || s?.Province)
          .filter(Boolean);
        return [...fromAR, ...fromServices];
      })
    )
  ).filter(Boolean);

  const handleFilter = async (filters) => {
    setFilterParams(filters || {});
    setCurrentPage(1);
    
    // Force table re-render by updating key
    setTableKey(prev => prev + 1);

    await loadAllCustomers(filters);
    await reloadCustomers(1, itemsPerPage, filters);
  };


  const handleSearch = async (filters) => {
    const keyword = filters?.keyword || "";
    const nextFilters = { ...(filterParams || {}), keyword };
    setFilterParams(nextFilters);
    setCurrentPage(1);
    await loadAllCustomers(nextFilters);  //  รวมทั้งระบบ
    await reloadCustomers(1, itemsPerPage, nextFilters);
  };

  const handleSaveCustomer = async (type, data) => {
    if (!hasOrgPermissionKey("page.sale_customer.create")) {
      Swal.fire("ไม่มีสิทธิ์", "ไม่มีสิทธิ์เพิ่มลูกค้า", "warning");
      return;
    }
    try {
      setLoading(true);

      let payload = {
        Comp_Id: authData?.Comp_Id || 1,
        Created_By_Name: authData?.Emp_Name || "System",
        Created_By_Id: authData?.Emp_Id || 0,
        Contract_EndDate: data?.Contract_EndDate || null,
        Competitor: data?.Competitor || "",
        DisplayName: String(data?.DisplayName || data?.AR_Name || "").trim(),
      };

      if (type === "personal") {
        payload = {
          ...payload,
          AR_Name: data?.AR_Name || "",
          AR_LastName: data?.AR_LastName || "",
          AR_TaxNo: data?.AR_TaxNo || "",
          AR_TitleCode: data?.AR_TitleCode || 0,
          AR_Tel: data?.AR_Tel || "",
          AR_Email: data?.AR_Email || "",
          AR_Line: data?.AR_Line || "",
          ServiceAddr_Type_Id: data?.AR_BuildingType || "",
          Province: data?.AR_Province || "",
          AR_Group: 1,
        };
      } else if (type === "corporate") {
        payload = {
          ...payload,
          AR_TitleCode: data?.AR_TitleCode || 0,
          AR_Name: data?.AR_Name || "",
          AR_TaxNo: data?.AR_TaxNo || "",
          AR_ContactName: data?.AR_ContactName || "",
          AR_ContactPosition: data?.AR_ContactPosition || "",
          AR_Tel: data?.AR_Tel || "",
          AR_Email: data?.AR_Email || "",
          AR_Line: data?.AR_Line || "",
          ServiceAddr_Type_Id: data?.AR_BuildingType || "",
          Province: data?.AR_Province || "",
          AR_Group: 2,
        };
      }

      await api.post("/create-tb-set-ar1", payload);
      setOpenCustomerModal(false);

      // await Swal.fire({ icon: "success", title: "สำเร็จ!",
      //   timer: 1500,
      //   showConfirmButton: false, });

      //  โหลดใหม่ทั้งสองแบบ
      await loadAllCustomers(filterParams);
      await reloadCustomers(currentPage, itemsPerPage, filterParams);

    } catch (error) {
      console.error("เพิ่ม/แก้ไขลูกค้าล้มเหลว:", error);
      Swal.fire("ผิดพลาด", "ไม่สามารถบันทึกข้อมูลลูกค้าได้", "error");
    } finally {
      setLoading(false);
    }
  };

  //  บันทึกผลการโทร (เหมือนเดิม...ไม่ตัด)
  const handleSaveCall = async (mode, formData) => {
    try {
      const toLocalISOString = () => {
        const now = new Date();
        const tzOffset = 7 * 60; 
        const local = new Date(now.getTime() + tzOffset * 60 * 1000);
        return local.toISOString().replace("Z", "+07:00");
      };

      const payload = {
        AR_Id: formData?.AR_Id || null,
        ServiceAddr_Id: formData?.ServiceAddr_Id || null,
        Comp_Id: authData?.Comp_Id || 1,
        Sale_Emp_Id: authData?.Emp_Id || null,
        Call_Result: formData?.Call_Result?.trim() || "",
        Call_Remark: formData?.Call_Remark?.trim() || "",
        Call_Date: toLocalISOString(),
        Call_Type: formData?.Call_Type || 1,
      };

      await api.post("/create-call", payload);
      setOpenCallModal(false);

      //  โหลดใหม่จากระบบทั้งหมด
      await loadAllCustomers(filterParams);
      await reloadCustomers(currentPage, itemsPerPage, filterParams);

    } catch (err) {
      console.error("Save Call Error:", err);
      Swal.fire("ผิดพลาด", "ไม่สามารถบันทึกผลการโทรได้", "error");
    }
  };

  //  บันทึกนัดหมาย (เหมือนเดิม)
  const isSavingAppointment = useRef(false);

  const handleSaveAppointment = async (mode, formData) => {
    if (isSavingAppointment.current) return;
    isSavingAppointment.current = true;

    try {
      const isFollowup = formData?.Purpose === "followup";
      const endpoint = isFollowup ? "/create-call" : "/create-appoint";

      let payload = {};

      if (isFollowup) {
        payload = {
          Comp_Id: formData?.Comp_Id,
          AR_Id: formData?.AR_Id,
          ServiceAddr_Id: formData?.ServiceAddr_Id,
          Sale_Emp_Id: formData?.Sale_Emp_Id,
          Call_Date: formData?.Appoint_Date,
          Time_Start: formData?.Time_Start,
          Time_End: formData?.Time_End,
          Call_Remark: formData?.Remark || "",
          Call_Type: 2,
        };
      } else {
        payload = {
          Purpose: "visit",
          Comp_Id: formData?.Comp_Id,
          AR_Id: formData?.AR_Id,
          ServiceAddr_Id: formData?.ServiceAddr_Id,
          Sale_Emp_Id: formData?.Sale_Emp_Id,
          Appoint_Date: formData?.Appoint_Date,
          Time_Start: formData?.Time_Start,
          Time_End: formData?.Time_End,
          Appoint_Remark: formData?.Remark || "",
        };
      }

      await api.post(endpoint, payload);

      setOpenAppointmentModal(false);

      // await Swal.fire({
      //   icon: "success",
      //   title: "สำเร็จ!",
      //   text: mode === "edit" ? "อัปเดตนัดหมายเรียบร้อย" : "บันทึกนัดหมายเรียบร้อย",
      //   timer: 1500,
      //   showConfirmButton: false,
      // });

      await loadAllCustomers(filterParams);
      await reloadCustomers(currentPage, itemsPerPage, filterParams);

    } catch (err) {
      Swal.fire("ผิดพลาด", "ไม่สามารถบันทึกข้อมูลได้", "error");
    } finally {
      isSavingAppointment.current = false;
    }
  };

  const handleOpenContactModal = (payload, type) => {
    try {
      const customer = allCustomers.find(
        (c) => String(c.AR_Id) === String(payload?.AR_Id)
      );
      if (!customer) return;

      const firstContact = customer?.Contacts?.[0] || {};
      const service = customer?.Services?.find(
        (s) => String(s.ServiceAddr_Id) === String(payload?.ServiceAddr_Id)
      );

      //  COMMON DEFAULT
      const defaultBase = {
        AR_Id: customer?.AR_Id || null,
        ServiceAddr_Id: payload?.ServiceAddr_Id || null,
        Comp_Id: authData?.Comp_Id || 1,
        Sale_Emp_Id: authData?.Emp_Id || null,
        Sale_Emp_Name: authData?.Emp_Name || "",
        AR_ContactId: firstContact?.AR_ContactId || null,
        AR_ContactName: firstContact?.AR_ContactName || "",
        AR_Tel: firstContact?.AR_Tel || "",
      };

      //  CASE 1 : บันทึกการโทร
      if (type === "result") {
        const calls = service?.Calls || [];
        const emptyResultCall =
          calls
            .filter(
              (c) =>
                !c?.Call_Result ||
                (typeof c.Call_Result === "string" && c.Call_Result.trim() === "")
            )
            .sort((a, b) => Number(b.Call_Id) - Number(a.Call_Id))?.[0];

        if (emptyResultCall) {
          //  แก้ mode=edit
          setCallData({
            ...defaultBase,
            ...emptyResultCall,
            mode: "edit",
          });
        } else {
          //  mode=create
          setCallData({
            ...defaultBase,
            Call_Id: null,
            Call_Date: new Date().toISOString().split("T")[0],
            Time_Start: "",
            Time_End: "",
            Call_Result: "",
            Call_Remark: "",
            Call_Type: 1,
            mode: "create",
          });
        }

        setOpenCallModal(true);
        return;
      }

      if (type === "appointment") {
          const defaultDate = selectedDate || new Date().toISOString().split("T")[0];

          const services = customer?.Services || [];

          // 🔥 เคสมีสถานที่เดียว → ใช้ทันที
          let resolvedServiceAddrId = null;
          if (services.length === 1) {
              resolvedServiceAddrId = services[0].ServiceAddr_Id;
          } else {
              // 🔥 เคสมีหลายสถานที่ → ใช้ที่กดมาจาก payload
              resolvedServiceAddrId = payload?.ServiceAddr_Id || null;
          }

          setAppointmentData({
              ...defaultBase,
              customer,
              contact: firstContact,
              ServiceAddr_Id: resolvedServiceAddrId,   // ⭐ สำคัญที่สุด!!
              mode: "create",
              Appoint_Date: defaultDate,
              Time_Start: "",
              Time_End: "",
              Appoint_Remark: service?.SpecRemark || "",
          });

          setOpenAppointmentModal(true);
      }


    } catch (e) {
      console.error("onOpenContactModal error:", e);
    }
  };


  const handleOpenGroupModal = (type) => {
    setGroupType(type);
    setOpenGroupModal(true);
  };
  const handleCloseGroupModal = () => {
    setGroupType("");
    setOpenGroupModal(false);
  };

  const viewData =
    activeGroup === "today"
      ? todayCustomers
      : activeGroup === "mine"
      ? myCustomers
      : activeGroup === "unassigned"
      ? unassignedCustomers
      : filteredCustomers;

  const totalForPagination =
    activeGroup === "all" ? totalFromServer : viewData.length;

  const getPaginatedView = () => {
    const from = (currentPage - 1) * itemsPerPage;
    const to = from + itemsPerPage;

    if (activeGroup === "today") {
      return todayCustomers.slice(from, to);
    }
    if (activeGroup === "mine") {
      return myCustomers.slice(from, to);
    }
    if (activeGroup === "unassigned") {
      return unassignedCustomers.slice(from, to);
    }
    return customers;
  };

  const handleFocusCustomer = (arId) => {
    const id = arId != null ? String(arId) : null;
    setFocusedArId(id);
    if (id) localStorage.setItem(SALE_FOCUS_AR_KEY, id);
  };

  // ---------------------- EMBEDDED MODE ----------------------
if (embedded) {
  return (
    <div className="sale-page w-full h-full bg-gray-50 flex flex-col overflow-hidden">
      <div className="flex-shrink-0 p-6 pb-4">
        {/* 🔍 Search Filter */}
        <SearchFilter
          onSearch={handleSearch}
          onCreate={() => {
            if (!hasOrgPermissionKey("page.sale_customer.create")) {
              Swal.fire("ไม่มีสิทธิ์", "ไม่มีสิทธิ์เพิ่มลูกค้า", "warning");
              return;
            }
            setOpenCustomerModal(true);
          }}
          onImport={() => setOpenImportModal(true)}
          onOpenList={() => setOpenCustomerListModal(true)}
          total={allCustomers.length}
          provinces={provinceOptions}
          customers={customers}
          activeGroup={activeGroup}
          setActiveGroup={setActiveGroup}
          todayCount={todayCustomers.length}
          mineCount={myCustomers.length}
          unassignedCount={unassignedCustomers.length}
          branchFilter={branchFilter}
          onBranchFilterChange={setBranchFilter}
          branches={branches}
        />
      </div>

      {/* 📋 Table Customer */}
      <div className="flex-1 overflow-hidden px-6 pb-6">
        {loading ? (
          <Loading />
        ) : (
            <TableCustomer
              key={`table-${tableKey}-${activeGroup}`}
              data={getPaginatedView()}
              totalAllRecords={allCustomers.length}
              totalRecords={totalForPagination}
              setData={setFilteredCustomers}
              reloadCustomers={reloadCustomers}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              onPageChange={setCurrentPage}
              onItemsPerPageChange={setItemsPerPage}
              onFilter={handleFilter}
              onOpenContactModal={handleOpenContactModal}
              activeGroup={activeGroup}
              setActiveGroup={setActiveGroup}
              todayCount={todayCustomers.length}
              mineCount={myCustomers.length}
              unassignedCount={unassignedCustomers.length}
              currentEmpName={authData?.Emp_Name || localStorage.getItem("name")}
              sortField={sortField}
              sortOrder={sortOrder}
              setSortField={setSortField}
              setSortOrder={setSortOrder}
              focusedArId={focusedArId}
              onFocusCustomer={handleFocusCustomer}
              branchFilter={branchFilter}
              onBranchFilterChange={setBranchFilter}
              branches={branches}
            />
        )}
      </div>

      {/* 🧩 Customer Modal */}
      <CustomerModal
        isOpen={openCustomerModal}
        onClose={() => setOpenCustomerModal(false)}
        customers={customers}
        onSave={handleSaveCustomer}
      />

      {/* 📄 Customer List Modal */}
      <CustomerListModal
        isOpen={openCustomerListModal}
        onClose={() => setOpenCustomerListModal(false)}
        customers={customers}
        onSelect={() => {}}
        onSearch={handleSearch}
      />

      {/* 📥 Import Customer Modal */}
      <ImportCustomerModal
        isOpen={openImportModal}
        onClose={() => setOpenImportModal(false)}
        customers={importCustomers}
      />

      {/* 🗓 Calendar */}
      {openCalendar && (
        <CalendarWrapper
          isOpen={openCalendar}
          onClose={() => setOpenCalendar(false)}
          customers={customers}
        />
      )}

      {/* 📞 Call */}
      <CallModal
        isOpen={openCallModal}
        onClose={() => setOpenCallModal(false)}
        initialData={callData}
        customerData={callData}
        onSave={handleSaveCall}
      />

      {/* 📅 Appointment */}
      <AppointmentModal
          isOpen={openAppointmentModal}
          onClose={() => setOpenAppointmentModal(false)}
          initialData={{ ...appointmentData, buttonType }}
          customerData={appointmentData}
          serviceAddrId={appointmentData?.ServiceAddr_Id}
          onSave={handleSaveAppointment}
          selectedDate={selectedDate}
          buttonType={buttonType}
      />

      {openGroupModal && (
        <ModalContainer>
          <div className="fixed inset-0 z-[1000] bg-transparent" onClick={handleCloseGroupModal} />
          <div
            className="fixed left-1/2 top-[100px] -translate-x-1/2 z-[1000]
                       w-11/12 max-w-6xl bg-white/80 backdrop-blur-sm
                       rounded-2xl shadow-2xl border border-white/50
                       p-6"
          >
            <button
              className="absolute top-3 right-3 text-gray-600 hover:text-red-600 text-lg"
              onClick={handleCloseGroupModal}
            >
              ✕
            </button>

            <h2 className="text-xl font-bold mb-4 text-gray-800">
              {groupType === "today" && "รายการที่ทำวันนี้"}
              {groupType === "mine" && "รายการของฉัน"}
              {groupType === "unassigned" && "ยังไม่มีผู้รับผิดชอบ"}
            </h2>

            <div className="max-h-[75vh] overflow-y-auto border rounded-xl bg-white/90">
              <TableCustomer
                data={
                  groupType === "today"
                    ? todayCustomers
                    : groupType === "mine"
                    ? myCustomers
                    : unassignedCustomers
                }
                setData={setFilteredCustomers}
                reloadCustomers={reloadCustomers}
                currentPage={1}
                itemsPerPage={10}
                onPageChange={() => {}}
                totalRecords={
                  groupType === "today"
                    ? todayCustomers.length
                    : groupType === "mine"
                    ? myCustomers.length
                    : unassignedCustomers.length
                }
                onItemsPerPageChange={() => {}}
                onFilter={handleFilter}
                onOpenContactModal={handleOpenContactModal}
              />
            </div>
          </div>
        </ModalContainer>
      )}

    </div>
  );
}

  return (
    <div className="sale-page flex text-14 h-screen overflow-hidden">
      <Sidebar />
      <main
        className="flex-1 h-screen bg-gray-50 flex flex-col"
        style={{
          height: "calc(100vh - 56px)",
          overflowX: "hidden",
          overflowY: "hidden",
          marginLeft: "var(--sidebar-width)",
          marginTop: "56px",
        }}
      >
        <div className="flex-shrink-0 pl-2 pr-6 pt-0.5">
          <Topbar
            breadcrumbs={[{ label: "ลูกค้า" }, { label: "รายการลูกค้า" }]}
            user={{
              name: authData?.Emp_Name || "ผู้ใช้งาน",
              role: authData?.PST_Name || "ตำแหน่ง",
            }}
          />
        </div>

        <div className="flex-shrink-0 pl-2 pr-6 pt-0 pb-0.5">
          <SearchFilter
            onSearch={handleSearch}
            onCreate={() => {
            if (!hasOrgPermissionKey("page.sale_customer.create")) {
              Swal.fire("ไม่มีสิทธิ์", "ไม่มีสิทธิ์เพิ่มลูกค้า", "warning");
              return;
            }
            setOpenCustomerModal(true);
          }}
            onImport={() => setOpenImportModal(true)}
            onOpenList={() => setOpenCustomerListModal(true)}
            total={allCustomers.length}
            provinces={provinceOptions}
            customers={customers}
            activeGroup={activeGroup}
            setActiveGroup={setActiveGroup}
            todayCount={todayCustomers.length}
            mineCount={myCustomers.length}
            unassignedCount={unassignedCustomers.length}
          />
        </div>

        <div className="flex-1 min-h-0 overflow-hidden pl-2 pr-6 pb-0">
          {loading ? (
            <Loading />
          ) : (
            <TableCustomer
              key={`table-${tableKey}-${activeGroup}`}
              data={getPaginatedView()}
              totalAllRecords={allCustomers.length}
              totalRecords={totalForPagination}
              setData={setFilteredCustomers}
              reloadCustomers={reloadCustomers}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              onPageChange={setCurrentPage}
              onItemsPerPageChange={setItemsPerPage}
              onFilter={handleFilter}
              onOpenContactModal={handleOpenContactModal}
              activeGroup={activeGroup}
              setActiveGroup={setActiveGroup}
              todayCount={todayCustomers.length}
              mineCount={myCustomers.length}
              unassignedCount={unassignedCustomers.length}
              currentEmpName={authData?.Emp_Name || localStorage.getItem("name")}
              sortField={sortField}
              sortOrder={sortOrder}
              setSortField={setSortField}
              setSortOrder={setSortOrder}
              focusedArId={focusedArId}
              onFocusCustomer={handleFocusCustomer}
              branchFilter={branchFilter}
              onBranchFilterChange={setBranchFilter}
              branches={branches}
            />
          )}
        </div>

        <CustomerModal
          isOpen={openCustomerModal}
          onClose={() => setOpenCustomerModal(false)}
          customers={customers}
          onSave={handleSaveCustomer}
        />

        <CustomerListModal
          isOpen={openCustomerListModal}
          onClose={() => setOpenCustomerListModal(false)}
          customers={customers}
          onSelect={() => {}}
          onSearch={handleSearch}
        />

        <ImportCustomerModal
          isOpen={openImportModal}
          onClose={() => setOpenImportModal(false)}
          customers={importCustomers}
        />

        {openCalendar && (
          <CalendarWrapper
            isOpen={openCalendar}
            onClose={() => setOpenCalendar(false)}
            customers={customers}
          />
        )}

        <CallModal
          isOpen={openCallModal}
          onClose={() => setOpenCallModal(false)}
          initialData={callData}
          customerData={callData}
          onSave={handleSaveCall}
        />

        <AppointmentModal
            isOpen={openAppointmentModal}
            onClose={() => setOpenAppointmentModal(false)}
            initialData={{ ...appointmentData, buttonType }}
            customerData={appointmentData}
            serviceAddrId={appointmentData?.ServiceAddr_Id}
            onSave={handleSaveAppointment}
            selectedDate={selectedDate}
            buttonType={buttonType}
        />




        {openGroupModal && (
          <ModalContainer>
            <div className="fixed inset-0 z-[1000] bg-transparent" onClick={handleCloseGroupModal} />
            <div
              className="fixed left-1/2 top-[100px] -translate-x-1/2 z-[1000]
                         w-11/12 max-w-6xl bg-white/80 backdrop-blur-sm
                         rounded-2xl shadow-2xl border border-white/50
                         p-6"
            >
              <button
                className="absolute top-3 right-3 text-gray-600 hover:text-red-600 text-lg"
                onClick={handleCloseGroupModal}
              >
                ✕
              </button>

              <h2 className="text-xl font-bold mb-4 text-gray-800">
                {groupType === "today" && "รายการที่ทำวันนี้"}
                {groupType === "mine" && "รายการของฉัน"}
                {groupType === "unassigned" && "ยังไม่มีผู้รับผิดชอบ"}
              </h2>

              <div className="max-h-[75vh] overflow-y-auto border rounded-xl bg-white/90">
                <TableCustomer
                  data={
                    groupType === "today"
                      ? todayCustomers
                      : groupType === "mine"
                      ? myCustomers
                      : unassignedCustomers
                  }
                  setData={setFilteredCustomers}
                  reloadCustomers={reloadCustomers}
                  currentPage={1}
                  itemsPerPage={10}
                  onPageChange={() => {}}
                  totalRecords={
                    groupType === "today"
                      ? todayCustomers.length
                      : groupType === "mine"
                      ? myCustomers.length
                      : unassignedCustomers.length
                  }
                  onItemsPerPageChange={() => {}}
                  onFilter={handleFilter}
                  onOpenContactModal={handleOpenContactModal}
                  branchFilter={branchFilter}
                  onBranchFilterChange={setBranchFilter}
                  branches={branches}
                />
              </div>
            </div>
          </ModalContainer>
        )}
      </main>
    </div>
  );
}
